module.exports = __webpack_public_path__ + "img/alarm.2fcb4906.png";